const Input = props => {
  let haveValue = false;

  if (props.value !== 0 && props.value !== "" && props.value) {
    haveValue = true;
  }

  return (
    <div className="input-container">
      <input {...props} className="input-text" />
      {haveValue && (
        <label className="placeholder-text">{props.placeholder || ""}</label>
      )}
    </div>
  );
};

export default Input;
